import { render, staticRenderFns } from "./VeeLabelEditList.vue?vue&type=template&id=1d741f6e&"
import script from "./VeeLabelEditList.vue?vue&type=script&lang=js&"
export * from "./VeeLabelEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports